import React from 'react';
import Map from './Map.js';
import './App.css';
import classnames from 'classnames';
import CSVReader from 'react-csv-reader'
import * as TripHelpers from './TripHelpers';

const days = [
  { id: 'Mo.', name: 'Monday' },
  { id: 'Di.', name: 'Tuesday' },
  { id: 'Mi.', name: 'Wednesday' },
  { id: 'Do.', name: 'Thursday' },
  { id: 'Fr.', name: 'Friday' },
  { id: 'Sa.', name: 'Saturday' },
  { id: 'So.', name: 'Sunday' },
]

function getDirectDistanceBetweenGeopoints(geopoint1, geopoint2) {
    // Source: https://www.movable-type.co.uk/scripts/latlong.html

    const R = 6371e3; // metres
    const φ1 = geopoint1.lat * Math.PI/180; // φ, λ in radians
    const φ2 = geopoint2.lat * Math.PI/180;
    const Δφ = (geopoint2.lat-geopoint1.lat) * Math.PI/180;
    const Δλ = (geopoint2.long-geopoint1.long) * Math.PI/180;

    const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
              Math.cos(φ1) * Math.cos(φ2) *
              Math.sin(Δλ/2) * Math.sin(Δλ/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

    const d = R * c; // in metres

    return d
}

class App extends React.Component {
  state = {
    selectedDayIndex: 0,
    selectedTripIndex: 0,

    allTrips: [],
    selectedTrips: [],
    selectedPolylines: [],
  }

  onFileLoaded(data, fileInfo, originalFile) {
    let header = data[0]
    let allTrips = []

    data.slice(1).forEach((tripData, index) => {
      let trip = {};

      header.forEach((headerItem, index) => {
        trip[headerItem] = tripData[index]
      });

      trip.distanceInKm = getDirectDistanceBetweenGeopoints({
        lat: trip.fromY,
        long: trip.fromX
      }, {
        lat: trip.toY,
        long: trip.toX
      })/1000
      trip.avgSpeedInKph = trip.distanceInKm / trip.durationTrip * 60

      allTrips.push(trip)
    });


    console.log(allTrips)
    this.setState({ allTrips })
    this.filterTrips()
  }

  async selectDay(index) {
    await this.setState({selectedDayIndex: index})
    this.filterTrips()
  }

  async selectTrip(index) {
    this.state.selectedPolylines[this.state.selectedTripIndex].setOptions(this.normalPolyline_options)
    this.state.selectedPolylines[index].setOptions(this.focussedPolyline_options)
    await this.setState({selectedTripIndex: index})
  }

  filterTrips(trips) {
    const dayId = days[this.state.selectedDayIndex].id;

    let selectedTrips = []
    let selectedPolylines = []

    this.state.allTrips.forEach((item, index) => {
      if(item.tripBeginDay == dayId) {
        selectedTrips.push(item)

        const polylinePath = [
          { lat: parseFloat(item.fromY), lng: parseFloat(item.fromX) },
          { lat: parseFloat(item.toY), lng: parseFloat(item.toX) },
        ]
        const polyline = new window.google.maps.Polyline({
          ...(selectedPolylines.length == 0 ? this.focussedPolyline_options : this.normalPolyline_options),
          path: polylinePath
        })
        polyline.setMap(this.map)
        selectedPolylines.push(polyline)
      }
    });

    this.deleteAllPolylines()
    this.setState({selectedTrips, selectedPolylines, selectedTripIndex: 0})
  }

  deleteAllPolylines() {
    this.state.selectedPolylines.forEach((item, index) => {
      item.setMap(null)
    })
  }

  render() {
    return (
      <div className="App">
        <div className="ListContainer">
          <div className="DropzoneContainer">
            <CSVReader
              cssClass="csv-reader-input"
              label="Select the output file from mobitopp for one person here (file format: .csv)."
              onFileLoaded={this.onFileLoaded.bind(this)}
              onError={() => {}}
              inputId="CSV File"
              inputName="CSV File"
              inputStyle={{color: 'red'}}
            />
          </div>

          <ol className="List">
            {days.map((item, index) => {
              return (
                <li
                  key={item.id}
                  onClick={() => this.selectDay(index)}
                  className={classnames({'ListItem': true, 'SelectedListItem': index === this.state.selectedDayIndex})}
                >
                  <div className="ListItemTitle"> {item.name} </div>
                </li>
              )
            })}
          </ol>

          <ol className="List">
            {this.state.selectedTrips.map((item, index) => {
              return (
                <li
                  key={item.tripId}
                  onClick={() => this.selectTrip(index)}
                  className={classnames({'ListItem': true, 'SelectedListItem': index === this.state.selectedTripIndex})}
                >
                  <div className="ListItemTitle"> {'Trip ' + item.tripId} </div>
                  {TripHelpers.getInfoStrings(item).map((item, index) => {
                    return (
                      <div> {item} </div>
                    )
                  })}
                </li>
              )
            })}
          </ol>
        </div>



        <Map
          id="myMap"
          options={{
            center: { lat: 48.8591174, lng: 8.2059096 },
            zoom: 9,
          }}
          onMapLoad={(map) => {
            this.map = map

            this.normalPolyline_options = {
              geodesic: true,
              strokeColor: '#000000',
              strokeOpacity: 0.4,
              strokeWeight: 2,
              icons: []
            }
            this.focussedPolyline_options = {
              geodesic: true,
              strokeColor: '#FF0000',
              strokeOpacity: 1,
              strokeWeight: 2,
              icons: [{
                icon: {path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW},
                offset: '100%'
              }]
            }

            this.filterTrips()
          }}
        />
      </div>
    );
  }
}

export default App;
